<template>
  <div class="page-container">
    <Header></Header>
    <FixedBox></FixedBox>
    <div class="page-content" id="pageContent">
      <div class="page-conent-container">
        <router-view v-slot="{ Component }">
          <!-- <keep-alive> -->
          <!--  class="animate__animated animate__slideInRight"  -->
          <component :is="Component" ref="componentRef" />
          <!-- </keep-alive> -->
        </router-view>
        <div class="page-footer">
          <Footer></Footer>
          <a-divider />
          <filing-information></filing-information>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
  provide
} from 'vue'
import Header from './header/index.vue'
import FixedBox from './fixedBox/index.vue'
import Footer from './footer/index.vue'
import filingInformation from './filing/index.vue'
import { useRoute } from 'vue-router'


const route = useRoute()

const path = computed(() => route.path)


const setDom = () => {
  let div = document.querySelector(".page-content")
  let headerDom = document.querySelector(".header-container")
  let _headerDom = document.querySelector(".header-responsive-container ")

  if (div && headerDom) {
    if (path.value == "/home") {
      div.style.paddingTop = "80px"
      headerDom.style.background = "#ffffff"
      if (div.offsetWidth < 800) {
        div.style.paddingTop = "65px"
      } else {
        div.style.paddingTop = "80px"
      }


    } else {
      div.style.paddingTop = "0px"
      headerDom.style.background = "transparent"
    }
  }
  if (_headerDom) {
    if (path.value == "/home") {

      _headerDom.style.background = "#ffffff"
    } else {

      _headerDom.style.background = "transparent"
    }
  }
}



watch(() => path.value, (newVal, oldVal) => {
  setDom()
}, { immediate: true, deep: true })



onMounted(() => {

  setDom()
})

</script>
<style scoped>
.page-container {
  width: 100%;
  height: 100%;
  /* display: flex;
    flex-direction: column; */
}

.page-container .page-header {
  height: 100px;
  background: rgba(255, 0, 0, 0.3);
}

.page-container .page-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  /* height: 100%; */
}

.page-conent-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.page-container .page-content .page-footer {
  /* height: 500px; */
  /* background: rgba(0, 0, 255, 0.3); */
  /* background: #2081EB; */
  background: url("../../assets//image//bg_footer.png");
}
</style>

<style>
.page-footer>.ant-divider-horizontal {
  margin: 0;
}
</style>
